var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m4 9a1 1 0 0 0 -1 1 9.01 9.01 0 0 0 8 8.941v3.059h-2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-2v-3.059a9.01 9.01 0 0 0 8-8.941 1 1 0 0 0 -2 0 7 7 0 0 1 -14 0 1 1 0 0 0 -1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12 15a5.006 5.006 0 0 0 5-5v-5a5 5 0 0 0 -10 0v5a5.006 5.006 0 0 0 5 5zm-3-10a3 3 0 0 1 6 0v5a3 3 0 0 1 -6 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.92afcf4d4c77b0826d5c333733972a62.svg";
export { ForwardRef as ReactComponent };